module.exports = __webpack_public_path__ + "static/media/learnExp.4221d111.png";